import React, { useState } from "react";
import ModalWrapper from "../common/ModalWrapper";

function CreateGroupModal({
  users = [],
  leadId = null,
  onCreate,
  onClose,
})

{  const [name, setName] = useState("");
  const [selected, setSelected] = useState([]);

  const toggleUser = (id) => {
    setSelected((prev) =>
      prev.includes(id)
        ? prev.filter((x) => x !== id)
        : [...prev, id]
    );
  };

  return (
    <ModalWrapper title="Create Group" onClose={onClose}>
      {/* Group Name */}
      <input
        className="form-control mb-3"
        placeholder="Group name"
        value={name}
        onChange={(e) => setName(e.target.value)}
      />

      {/* Users List */}
      <div
        className="group-user-list"
        style={{ maxHeight: "300px", overflowY: "auto" }}
      >
        {users.length === 0 ? (
          <p className="text-muted text-center">No users available</p>
        ) : (
          users.map((u) => (
            <label
              key={String(u._id)}
              className="group-user-item d-flex gap-2 align-items-center py-1"
            >
              <input
                type="checkbox"
                checked={selected.includes(String(u._id))}
                onChange={() => toggleUser(String(u._id))}
              />
              <span>{u.name}</span>
            </label>
          ))
        )}
      </div>

      {/* Create Button */}
      <button
        className="btn btn-primary w-100 mt-3"
        disabled={!name.trim() || selected.length === 0}
onClick={() => onCreate(name.trim(), selected, leadId)}      >
        Create Group
      </button>
    </ModalWrapper>
  );
}

export default CreateGroupModal;
